import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/sales-category',
  title: 'Categoria de Vendas',
  endpoint: '/app/purchase_category',
  breadcrumbs: [],
}
